// src/i18n/es/tags.js
const tags = {
    fields: {
        phone_number: 'Número de teléfono',
    },
    notifications: {
        pdf_downloaded: 'PDF descargado correctamente',
        pdf_error: 'Error al generar PDF',
        qr_generation_error: 'Error al generar código QR',
        sms_not_available: 'Servicio SMS no disponible',
        phone_required: 'Número de teléfono requerido',
        sms_sent: 'SMS enviado correctamente',
        sms_error: 'Error al enviar SMS',
        qr_not_ready: 'Código QR no está listo',
        qr_copied: 'Imagen QR copiada al portapapeles',
        code_copied: 'Código copiado al portapapeles',
    },
    download: {
        a4: 'Descargar A4',
        ticket: 'Descargar Ticket',
    },
    actions: {
        download_pdf: 'Descargar PDF',
        print: 'Imprimir',
        share_qr: 'Compartir QR',
        copy_qr: 'Copiar imagen QR',
        send_sms: 'Enviar SMS',
    },
    pdf: {
        locker_access_code: 'Código de Acceso a Taquilla',
        digital_locker_card: 'Acceso a Taquilla',
        instructions_title: 'Instrucciones de Uso',
        instruction_1: 'Diríjase a la zona de taquillas',
        instruction_2: 'Introduzca su código o escanee el código QR',
        instruction_3: 'Su taquilla asignada se abrirá automáticamente',
        environmental_message: '¡Gracias!',
        contact_help: '¿Necesita ayuda? Contacte nuestra recepción'
    },
};

export default tags;
